// extracted by mini-css-extract-plugin
export default {"container":"CallToBuy_container__Txekt","titleContainer":"CallToBuy_titleContainer__vA4Ci","title":"CallToBuy_title__XEWd5","subtitle":"CallToBuy_subtitle__pbXdn"};